import { useState } from "react";
import { Plus, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useApi } from "../lib/api";
import { PageHead, Input, Field, Select, Btn, Card, Loading } from "../components/kit";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { ROLE_LABEL } from "../lib/constants";

function UserDialog({ u, onClose, onSaved }) {
  const [f, setF] = useState({ ...u, password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      f.id ? await api.put(`/users/${f.id}`, f) : await api.post("/users", f);
      toast.success("Akun disimpan");
      onSaved();
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="user-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Edit Akun" : "Akun Baru"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Field label="Nama lengkap"><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="user-name-input" /></Field>
          <Field label="Username"><Input required autoCapitalize="none" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="user-username-input" /></Field>
          <Field label="Peran"><Select options={Object.entries(ROLE_LABEL)} value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="user-role-select" /></Field>
          <Field label={f.id ? "Password baru (kosongkan jika tidak diganti)" : "Password"}><Input type="password" required={!f.id} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="user-password-input" /></Field>
          <label className="flex items-center gap-3 h-12"><input type="checkbox" className="w-6 h-6 accent-sky-500" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} data-testid="user-active-checkbox" /> <span className="font-semibold">Akun aktif</span></label>
          <Btn type="submit" loading={busy} className="w-full" data-testid="user-save-btn">Simpan</Btn>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default function Users() {
  const [edit, setEdit] = useState(null);
  const { data, mutate } = useApi("/users", 0);
  return (
    <>
      <PageHead title="Pengguna" sub="Kelola akun dan hak akses" action={<Btn onClick={() => setEdit({ name: "", username: "", role: "operator", active: true })} data-testid="add-user-btn"><Plus className="w-5 h-5" /> <span className="hidden sm:inline">Akun</span></Btn>} />
      {!data ? <Loading /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="user-list">
          {data.map((u) => (
            <Card key={u.id} className={`flex items-center gap-3 ${u.active ? "" : "opacity-50"}`} data-testid={`user-${u.username}`}>
              <div className="w-12 h-12 rounded-xl bg-slate-900 text-white grid place-items-center font-extrabold text-lg">{u.name[0]?.toUpperCase()}</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{u.name}</div>
                <div className="text-xs text-slate-500">@{u.username} · {ROLE_LABEL[u.role]}{!u.active && " · Nonaktif"}</div>
              </div>
              <button onClick={() => setEdit(u)} className="h-11 w-11 grid place-items-center rounded-xl bg-slate-100" data-testid={`edit-user-${u.username}`}><Pencil className="w-5 h-5" /></button>
            </Card>
          ))}
        </div>
      )}
      {edit && <UserDialog u={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); mutate(); }} />}
    </>
  );
}
